import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store/store'
import i18n from './i18n/i18n'

import imports from './imports'
import fnMixin from './functions'

imports(Vue).use()
imports(Vue).components()
imports(Vue).filters()
imports(Vue).directives()

fnMixin(Vue)

export const bus = new Vue()

Vue.config.productionTip = false

const vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

global.vm = vm
global.$url = require('../API_URLS.json')

import sentry from './sentry'
sentry(Vue, vm)

import './utils/customRules'
